import Model from './Model';

export default class Integration extends Model {
  resource() {
    return 'integrations';
  }

  baseURL() {
    return `${window.config.apiUrl.split('/api')[0]}/api/groovedigital`;
  }
}
